
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  AlertBoxOptions,
  AlertBoxStyleV,
  AlertBoxStyle
} from "@/types/controls";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import TipTapWrapper from "@/components/Reusable/CustomInputs/3rdPartyWrappers/TipTapWrapper.vue";

const DEFAULT_OPTIONS: AlertBoxOptions = {
  style: "default",
  content: ""
};

@Component({
  components: { DropdownInput, TipTapWrapper }
})
export default class ElementStudioAlertBoxOptions extends Vue {
  @Prop()
  value!: AlertBoxOptions;

  get internalValue() {
    return this.value || DEFAULT_OPTIONS;
  }

  get styles() {
    return AlertBoxStyleV.types.map(type => type.value);
  }

  updateStyle(style: AlertBoxStyle) {
    this.emit({
      ...this.internalValue,
      style
    });
  }

  updateContent(content: string | null) {
    this.emit({
      ...this.internalValue,
      content: content ?? ""
    });
  }

  emit(alertBoxOptions: AlertBoxOptions) {
    this.$emit("input", alertBoxOptions);
  }
}
